import React from "react";
import { AVATAR } from "../../lib/assets";
import { Link } from "react-router-dom";

export const BlogAuthorInfo = () => {
  return (
    <div className="blog-avatar-wrap mb-65">
      <div className="blog-avatar-img">
        <Link to='#'>
          <img src={AVATAR} alt="img" />
        </Link>
      </div>

      <div className="blog-avatar-info">
        <span className="designation">Author</span>
        <h4 className="name">
          <Link to='#' >Parker Willy</Link>
        </h4>

        <p>
          Finanappreciate your trust greatly Our clients choose dentace ducts
          because kn ow we are the best area Awaitingare really.
        </p>
      </div>
    </div>
  );
};
